export default function IconMinusCircle({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0.53 0.53 16.95 16.95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M5.83691 9H12.1632"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.0918 8.99961C1.0918 10.0381 1.29634 11.0664 1.69374 12.0258C2.09115 12.9852 2.67363 13.857 3.40794 14.5913C4.14225 15.3256 5.014 15.9081 5.97342 16.3055C6.93284 16.7029 7.96114 16.9074 8.99961 16.9074C10.0381 16.9074 11.0664 16.7029 12.0258 16.3055C12.9852 15.9081 13.857 15.3256 14.5913 14.5913C15.3256 13.857 15.9081 12.9852 16.3055 12.0258C16.7029 11.0664 16.9074 10.0381 16.9074 8.99961C16.9074 6.90233 16.0743 4.89094 14.5913 3.40794C13.1083 1.92494 11.0969 1.0918 8.99961 1.0918C6.90233 1.0918 4.89094 1.92494 3.40794 3.40794C1.92494 4.89094 1.0918 6.90233 1.0918 8.99961Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
